import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import KeyboardVoiceIcon from '@material-ui/icons/KeyboardVoice';
import Icon from '@material-ui/core/Icon';
import SaveIcon from '@material-ui/icons/Save';

const useStyles = makeStyles((theme) => ({
    button: {
      margin: theme.spacing(1),
    },
  }));
  
  export default function IconLabelButton(props) {
    const classes = useStyles();
      return (
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.button}
          startIcon={props.icon}
          onClick={props.onClick}
          {...props}
        >
          {props.text}
        </Button>
    );
  }